<template>
  <div class="search-app-transition" data-behavior="vue-search-app">
    <Home />
  </div>
</template>

<script>
import Home from "./views/Home";

import $ from "webpack-zepto";
import _ from "lodash";
import * as Url from "domurl";

const $pageContent = $("[data-behavior='vue-search-app__page-content']");
const $mainContent = $("[data-behavior='vue-search-app__main-content']");

const searchAppSelector = "[data-behavior='vue-search-app']";

export default {
  name: "SearchApp",
  components: {
    Home,
  },
  data: function () {
    return {
      $searchApp: undefined,
      historyStateLocked: false,
    }
  },
  computed: {     
      searchActive: {
          get() {
              return this.$store.state.searchActive;
          },
          set(value) {
              this.$store.commit('setSearchActive', value);
          }
      },   
      discoverMode: {
          get() {
            return this.$store.state.discoverMode;
          },
          set(value) {
            this.$store.commit('setDiscoverMode', value);
          }
      },             
  },
  methods: {
      activateSearch(e) {
          // block the default click event handler on the search buttons, 
          // but not on the autocomplete input, so the autocomplete clear and 
          // other keyboard events would still work
          if ( e && ( e.currentTarget.nodeName === "BUTTON" || e.currentTarget.nodeName === "A" ) ) { e.preventDefault(); }
          
          // display the search app and calculate the height
          if (!this.searchActive) {                    
              this.searchActive = true;
              this.setContentHeight();
          }
      },
      setContentHeight() {
        // content height calculation and fade transitions
        if (this.searchActive) {

          // show the search app
          this.$searchApp.addClass("fadeIn");

          // calculate the app's container's height ($mainContent), 
          // so the absolute positioned app ($searchApp) can fade in
          // (add the extra padding to it as well)
          $mainContent.height(
              this.$searchApp.height() + 
              parseInt($mainContent.css("padding-top"), 10)
          );

          // fade out the original page ($pageContent)
          $pageContent.addClass("fadeOut");

          // extend the background color to the outter container 
          // in case the height calculation is not correct to avoid the white gaps
          $mainContent.addClass("has-bg-gray-10");                  
          
          // completely hide the original page (display:none)
          setTimeout(() => { 
            $pageContent.addClass("hide"); 
          }, 500);
        }
      },
      subscribeToStoreMutations() {
        // Subscribing to store mutations, to watch 
        // - the search term change and
        // - store active states
        this.unsubscribe = this.$store.subscribe((mutation, state) => { // eslint-disable-line no-unused-vars
          switch (mutation.type) {

            // watching the search term change and trigger: 
            // - fetch new search results
            // - pushing the new url to history (unless the state is locked - when navigating with the browser back/forward buttons)        
            case 'setSearchTerm':
              this.$store.dispatch('getSearchResults');
              
              this.discoverMode = false;

              if (!this.historyStateLocked) {
                window.history.pushState({}, 'Search Results', `/search-results?q=${this.$store.state.searchTerm}`);
              } else {
                this.historyStateLocked = false;
              }            
              break;

            // scroll to top once the app is active (visible), 
            // if the app is in the initial discover mode, push the discover url to history
            case 'setSearchActive':
              if ( this.searchActive ) {
                window.scroll({ top: 0, left: 0, behavior: 'smooth' });             
              }
              if ( this.discoverMode ) {
                window.history.pushState({}, 'Discover', `/discover`);              
              }
              break;
          }      
        });        
      },
      simplifiedRouting() {
        // landing on search and discover URLs
        let url = new Url(window.location.href);

        // debug mode is true, add extra class to show debug info
        if (url.query["debug"] === "true") {
          $mainContent.addClass("debug-mode");
        }

        // if we're coming in from a search results url
        // - commit the search term to the store
        // - turn off discover mode
        // - set the search to active (displays the search app)
        if (url.path.indexOf("/search-results") > -1) {
          this.$store.commit('setSearchTerm', url.query["q"]);
          this.discoverMode = false;
          this.searchActive = true;
        }

        // if we're coming in from the discover URL
        if (url.path.indexOf("/discover") > -1) {
          $mainContent.height(1200);
          this.searchActive = true;
        }              
      },
      historyManagement() {
        // listening to history changes
        let url = new Url(window.location.href);
        const app = this;

        window.addEventListener('popstate', () => { 
          // lock the history state when using browser's back/forward buttons
          // so we're not stuck in a loop, re-writing the same url all over again
          app.historyStateLocked = true;

          // parse the current URL
          url = new Url(window.location.href);          
          
          if (url.query["q"] !== undefined) {
            // push the URL's term the the store, 
            // so the application state is updated and we're showing the correct results
            app.$store.commit('setSearchTerm', url.query["q"]);

            // show the search app
            this.searchActive = true;
          }

        });        
      },
      heightCalulationEventHandlers() {
        // height calculation event listener (on resize, throttled)
        $(window).on('resize', 
            _.debounce(this.setContentHeight, 500, { 'leading': true }));

        // height calculation event listener 
        // - the search results (filter tabs) and 
        // - the appearing/disappearing grids 
        // kick off the re-calculation
        $(document).on('SearchAppUpdated', ()=>{
            this.setContentHeight();      
        });        
      },
      searchActivationEventHandler() {
        // Display (Activate) the search app
        // used by:
        // - the Autocomplete search button, 
        // - the Autocomplete input and 
        // - the mobile search button
        $(document).on('SearchAppActivated', (event, pointerEvent) => {
          this.activateSearch(pointerEvent);
        });        
      },
  },
  mounted() {
    // cache the app's dom element
    this.$searchApp = $(searchAppSelector);
    
    // delaying the height calculation, re-calculate every x seconds
    let intervalCounter = 0;
    let heightCalcInterval = setInterval(() => { 
      $(document).trigger('SearchAppUpdated');
      intervalCounter++;
      if (intervalCounter > 5) { clearInterval(heightCalcInterval); }
    }, 1500);

  },
  beforeDestroy() {
      this.unsubscribe();
  },  
  created() {
    // get the most popular and recommended results from the store
    this.$store.dispatch('getMostPopular');
    this.$store.dispatch('getRecommended');

    // execute methods
    this.subscribeToStoreMutations();
    this.simplifiedRouting();
    this.historyManagement();
    this.heightCalulationEventHandlers();
    this.searchActivationEventHandler();
  }
};
</script>

<style>
    .search-app-transition {
      height: 0;
      opacity: 0;
      transition: opacity 0.5s;
      overflow: hidden;
      display: none;
    }
    .search-app-transition.fadeIn {
      height: auto;
      opacity: 1;
      position: absolute;
      width: 100%;
      display: block;
    }
    #render-body {
      transition: opacity 0.5s;  
    }
    #render-body.fadeOut {
      opacity: 0;
      overflow: hidden;
    }
    #render-body.hide {
      display: none;
    }       
</style>